import useAgentMessages from "../../../hooks/aiAgent/useAgentMessages";
import useVoiceRecorder from "../../../hooks/aiAgent/useVoiceRecorder";
import ErrorModal from "../../modal/error/ErrorModal";
import classes from "./AgentInput.module.css";
import { useMemo, useState } from "react";

const AgentInput = ({ message, setMessage, setOpen, setChatMessages, allCategories, lang, t }) => {
  const [loading, setLoading] = useState(false);
  const [micError, setMicError] = useState(false);

  const isFirefox = useMemo(
    () => /firefox/i.test(navigator.userAgent
  ), []);

  const { sendVoice, sendText, cancel } = useAgentMessages({ setChatMessages, setLoading, setOpen, allCategories });

  const { isRecording, toggle: toggleMic } = useVoiceRecorder({
    onRecordingStop: sendVoice,
    sendText,
    onError: () => { setMicError(true); setOpen("") },
    lang,
  });

  const handleSend = () => {
    sendText(message);
    setMessage("");
  };

  return (
    <>
      <div className={classes.inputRow}>
        <input
          className={classes.input}
          placeholder={t("enter_message")}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />
        <button
          className={`${classes.micBtn} ${isRecording ? classes.recording : ""}`}
          onClick={toggleMic}
          disabled={isFirefox || loading}
          title={isFirefox ? t("browser_not_supported") ?? "Browser did not support" : ""}
        >
          <img src="/assets/aiAgent/microphone.svg" alt="" width="20" height="20" />
        </button>
        <button className={classes.sendBtn} disabled={isRecording} onClick={loading ? cancel : handleSend}>
          <img src={`/assets/aiAgent/${loading ? "cancel" : "send"}.svg`} alt="" width="28" height="28" />
        </button>
      </div>
      <ErrorModal show={micError} onHide={() => setMicError(false)} errorMessage={t("microphone_error_msg")} />
    </>
  );
};

export default AgentInput;